import {Component} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html',
  styles: [`.abc {
    cursor: pointer;
  }
  .logo {
    position: relative;
    height: 35px;
    width: 120px;
  }`]
})
export class AppHeaderComponent {
  constructor(private router: Router) {
  }

  logout() {
    localStorage.clear();
    this.router.navigate(['/login']);
  }

}



// WEBPACK FOOTER //
// /home/ashutosh/submission/src/app/dashboardcomponents/app-header/app-header.component.ts